import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { translator } from '../../utils/Translator';

// --- START: นำฟังก์ชัน Helper มารวมไว้ในไฟล์นี้ ---

/**
 * ดึงรายการไฟล์ที่เกี่ยวข้องกับเอกสารจาก FileStorage API
//  * @param {string} token - Token สำหรับการยืนยันตัวตน
//  * @param {string} relatedType - ประเภทของเอกสาร (เช่น 'expense', 'order')
//  * @param {string} relatedId - ID ของเอกสารที่ต้องการดึงไฟล์แนบ
//  * @param {string} [company] - รหัสบริษัท (ถ้าไม่ระบุจะใช้ค่าเริ่มต้นเป็น '89')
//  *  @param {string} fileName - ชื่อไฟล์
//  * @returns {Promise<Array<object>>} - Promise ที่จะคืนค่าเป็น Array ของ Object ไฟล์ หรือ Array ว่างหากไม่สำเร็จ
 */
// const fetchFileStorage = async (
//   token,
//   relatedType,
//   relatedId,
//   company ,
//   fileName
// ) => {
//   if (!token || !relatedType || !relatedId) {
//     console.error(' Missing required parameters for fetchFileStorage (token, relatedType, relatedId)');
//     return [];
//   }

//   try {
//     const FILE_UPLOAD_URL = process.env.FILE_UPLOAD_URL || 'http://services.ismartsales.com/file-manage/';
//     const baseUrl = FILE_UPLOAD_URL.replace(/\/$/, '');
//     const companyCode = company || '89';
//     // Endpoint สำหรับการดึงข้อมูลไฟล์ (GET)
//     const endpoint = `${baseUrl}/upload-multiple/${companyCode}/${relatedType}/${relatedId}/${fileName}`;

//     console.log(`📡 Fetching files from: ${endpoint}`);

//     const response = await axios.get(endpoint, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       timeout: 15000,
//       validateStatus: (status) => status < 500
//     });

//     console.log("API Response:", response.status, response.data);

//     switch (response.status) {
//       case 200:
//       case 201:
//         const files = response.data?.FileStorage || response.data?.files || response.data || [];
//         return Array.isArray(files) ? files : [];
//       case 403:
//         console.warn(`🚫 Access forbidden (403)`);
//         return [];
//       case 404:
//         console.log('ℹ️ No files found for this record (404)');
//         return [];
//       default:
//         console.warn(` Unexpected response status: ${response.status}`);
//         return [];
//     }
//   } catch (error) {
//     console.error(' Error fetching FileStorage:', error.message);
//     if (error.response) {
//       console.error(`🔥 Server Error: ${error.response.status}`, error.response.data);
//     } else if (error.request) {
//       console.error('🌐 Network error - no response received');
//     } else {
//       console.error(' Request setup error:', error.message);
//     }
//     return [];
//   }
// };




const fetchFileStorage = async (token, relatedType, relatedId, company) => {
  try {
    const FILE_UPLOAD_URL = process.env.FILE_UPLOAD_URL || 'https://services.ismartsales.com/file-manage/';
    const baseUrl = FILE_UPLOAD_URL.replace(/\/$/, '');
    const endpoint = `${baseUrl}/upload-multiple/81/related/stockcount/${relatedId}`; // Updated relatedType to 'stockcount'


    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      timeout: 15000,
      validateStatus: (status) => status < 500
    });


    if (response.status === 200 || response.status === 201) {
      const files = response.data?.data || response.data?.FileStorage || response.data?.files || response.data || [];
      return files;
    } else if (response.status === 403) {
      console.warn(`🚫 Access forbidden (403) - Check token permissions or API endpoint`);
      return [];
    } else if (response.status === 404) {
      return [];
    } else {
      console.warn(` Unexpected response status: ${response.status}`);
      return [];
    }
  } catch (error) {
    console.error(" fetchFileStorage error:", error);
    return [];
  }
};
  
  





// /**
//  * สร้าง URL ที่สมบูรณ์สำหรับเข้าถึงไฟล์
//  * @param {string} filePath - Path ของไฟล์ที่ได้จาก API
//  * @param {string} fileName - ชื่อไฟล์
//  * @param {string} [company] - รหัสบริษัท
//  * @param {string} [relatedType] - ประเภทเอกสาร
//  * @param {string} [relatedId] - ID เอกสาร
//  * @returns {string} - URL ที่สมบูรณ์ของไฟล์
//  */
const getFileUrl = (filePath, fileName, company, relatedType, relatedId) => {
  const FILE_UPLOAD_URL = process.env.FILE_UPLOAD_URL || 'https://services.ismartsales.com/file-manage/';
  const baseUrl = FILE_UPLOAD_URL.replace(/\/$/, '');

  // ถ้า filePath เป็น URL สมบูรณ์แล้ว
  if (filePath && filePath.startsWith('https')) {
    return filePath;
  }

  // สำหรับ stockcount ใช้รูปแบบ: /upload-multiple/81/related/stockcount/{relatedId}/{fileName}
  if (relatedType === 'stockcount' && relatedId && fileName) {
    return `${baseUrl}/upload-multiple/81/related/stockcount/${relatedId}/${fileName}`;
  }

  // สำหรับ expense ใช้รูปแบบ: /upload-multiple/81/related/expense/{relatedId}/{fileName}
  if (relatedType === 'expense' && relatedId && fileName) {
    return `${baseUrl}/upload-multiple/81/related/expense/${relatedId}/${fileName}`;
  }

  // รูปแบบทั่วไป
  if (company && relatedType && relatedId && fileName) {
    return `${baseUrl}/upload-multiple/${company}/${relatedType}/${relatedId}/${fileName}`;
  }

  // ถ้ามี filePath และ fileName
  if (filePath && fileName) {
    return `${baseUrl}/upload-multiple/${filePath}/${fileName}`;
  }

  // กรณีมีแค่ fileName
  if (fileName) {
    console.warn("getFileUrl: Constructing URL with only fileName might be unreliable.");
    return `${baseUrl}/upload-multiple/${fileName}`;
  }

  return baseUrl;
};

// --- END: จบส่วนของฟังก์ชัน Helper ---


const StockCountUploadDialog = ({ open, onClose, onUploadSuccess, relatedId, relatedType }) => {
    // Allowed extensions (update this list to add/remove supported file types)
    const ALLOWED_EXTENSIONS = [
        '.xlsx', '.xls', '.csv',
        '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp',
        '.pdf', '.doc', '.docx', '.ppt', '.pptx', '.txt',
        '.zip', '.rar', '.7z'
    ];

    const acceptAttr = ALLOWED_EXTENSIONS.join(',');

    const [files, setFiles] = useState([]);
    const fileInputRef = useRef();
    const [uploading, setUploading] = useState(false);
    const [loadingExisting, setLoadingExisting] = useState(false);
    const { authUser } = useSelector(({ auth }) => auth);
    const { translate } = useSelector(({ i18n }) => i18n);

    useEffect(() => {
        const fetchExistingFiles = async () => {
            if (!relatedId) return;

            setLoadingExisting(true);
            try {
                const token = localStorage.getItem("x-access-token");
                const company = authUser?.company;



                // เรียกใช้ฟังก์ชันที่ประกาศไว้ด้านบนของไฟล์นี้
                const existingFilesData = await fetchFileStorage(token, "stockcount", relatedId, company);


                if (existingFilesData && existingFilesData.length > 0) {
                    const mappedFiles = existingFilesData.map(file => {
                        // ใช้ "stockcount" แทน relatedType เพื่อให้ตรงกับ API endpoint
                        const url = getFileUrl(file.FilePath, file.FileName, company, "stockcount", relatedId);

                        
                        return {
                            name: file.FileName,
                            fileName: file.FileName,
                            fileUrl: url,
                            preview: url,
                            isExisting: true,
                        };
                    });
                    setFiles(mappedFiles);
                } else {
                    setFiles([]);
                }
            } catch (error) {
                setFiles([]);
            } finally {
                setLoadingExisting(false);
            }
        };

        if (open) {
            fetchExistingFiles();
        } else {
            setFiles([]);
        }

    }, [open, relatedId, relatedType, authUser]);

    if (!open) return null;

    const handleFileChange = e => {
        const selected = Array.from(e.target.files || []);
        if (selected.length === 0) return;

        const allowed = [];
        const rejected = [];

        selected.forEach((file) => {
            const name = file.name || '';
            const ext = name.includes('.') ? name.slice(name.lastIndexOf('.')).toLowerCase() : '';
            if (!ext || ALLOWED_EXTENSIONS.includes(ext)) {
                allowed.push(file);
            } else {
                rejected.push(name);
            }
        });

        if (rejected.length > 0) {
            alert(`${translator(translate.ISA_FilesRejected, "ไฟล์บางรายการถูกปฏิเสธ (นามสกุลไม่รองรับ)")}:\n${rejected.join('\n')}`);
        }

        if (allowed.length === 0) {
            e.target.value = '';
            return;
        }

        const mapped = allowed.map(file => ({
            file,
            name: file.name,
            preview: file.type && file.type.startsWith('image/') ? URL.createObjectURL(file) : null,
            isExisting: false
        }));
        setFiles(prev => [...prev, ...mapped]);
        e.target.value = '';
    };

     const handleRemove = async (idx) => {
    const fileToRemove = files[idx];
    if (!fileToRemove) return;

    // ถ้าเป็นไฟล์ใหม่ที่ยังไม่ได้อัปโหลด
    if (!fileToRemove.isExisting) {
      setFiles((prev) => {
        if (fileToRemove.preview && fileToRemove.preview.startsWith("blob:")) {
          URL.revokeObjectURL(fileToRemove.preview);
        }
        return prev.filter((_, i) => i !== idx);
      });
      return;
    }

    // ถ้าเป็นไฟล์ที่มีอยู่แล้วในระบบ
    const confirmDelete = window.confirm(
      `${translator(translate.ISA_ConfirmDeleteFile, "ต้องการลบไฟล์")} "${fileToRemove.name}" ${translator(translate.ISA_ConfirmQuestion, "ใช่หรือไม่")}?`
    );
    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("x-access-token");
      const FILE_UPLOAD_URL =
        process.env.FILE_UPLOAD_URL ||
        "https://services.ismartsales.com/file-manage/";
      const baseUrl = FILE_UPLOAD_URL.replace(/\/$/, "");

      // ดึง fileName จาก fileUrl หรือ preview
      const fileUrl = fileToRemove.fileUrl || fileToRemove.preview || "";
      const fileName = fileUrl.split(/[\/\\]/).pop();


      // ลบไฟล์โดยใช้ fileName
      const endpoint = `${baseUrl}/upload-multiple/${fileName}`;

      const resp = await axios.delete(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        validateStatus: (status) => status < 500,
      });


      if (resp.status === 200 || resp.status === 204 || resp.status === 201) {
        // ลบไฟล์ออกจาก UI
        setFiles((prev) => prev.filter((_, i) => i !== idx));
        alert(translator(translate.ISA_DeleteFileSuccess, "ลบไฟล์เรียบร้อยแล้ว"));
        if (onUploadSuccess) onUploadSuccess();
      } else {
        console.warn(" Delete response:", resp.status, resp.data);
        alert(translator(translate.ISA_CannotDeleteFile, "ไม่สามารถลบไฟล์ได้ โปรดลองอีกครั้ง"));
      }
    } catch (err) {
      console.error(" Delete error:", err);
      alert(translator(translate.ISA_ErrorDeleteFile, "เกิดข้อผิดพลาดขณะลบไฟล์"));
    }
  };

    // helper: return a FontAwesome icon class based on extension
    const getIconClassForExtension = (fileName) => {
        const ext = (fileName || '').toLowerCase().split('.').pop();
        switch (ext) {
            case 'pdf': return 'fa-solid fa-file-pdf';
            case 'xls':
            case 'xlsx': return 'fa-solid fa-file-excel';
            case 'doc':
            case 'docx': return 'fa-solid fa-file-word';
            case 'ppt':
            case 'pptx': return 'fa-solid fa-file-powerpoint';
            case 'zip':
            case 'rar':
            case '7z': return 'fa-solid fa-file-zipper';
            case 'txt': return 'fa-solid fa-file-lines';
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
            case 'bmp':
            case 'webp': return 'fa-solid fa-file-image';
            case 'csv': return 'fa-solid fa-file-csv';
            default: return 'fa-solid fa-file';
        }
    };

    const handleAddClick = () => {
        if (fileInputRef.current) fileInputRef.current.click();
    };


   
    const uploadAllFiles = async (fileList) => {
        const token = localStorage.getItem("x-access-token");

        if (!token) {
            throw new Error("Authentication token is required");
        }

        if (!fileList || fileList.length === 0) {
            throw new Error("No files provided for upload");
        }

        const now = new Date();
        const pad = (n, width = 2) => n.toString().padStart(width, '0');

        const createdAtFormatted =
            now.getUTCFullYear().toString() +
            pad(now.getUTCMonth() + 1) +
            pad(now.getUTCDate()) +
            pad(now.getUTCHours()) +
            pad(now.getUTCMinutes()) +
            pad(now.getUTCSeconds()) +
            pad(now.getUTCMilliseconds(), 3);

        const directory = {
            CompanyCode: authUser?.company || "DEFAULT",
            RelatedID: relatedId,
            RelatedType: 'stockcount',
            CreatedAt: createdAtFormatted,
            CreatedBy: authUser?.displayName || authUser?.username || "user",
            AlbumCode: "stockcount-attachments",
        };


        const results = [];

        for (const file of fileList) {
            try {
                const formData = new FormData();
                formData.append("files", file);
                formData.append("directory", JSON.stringify(directory));

               const response = await axios.post(
                                   `https://services.ismartsales.com/file-manage/upload-multiple`,
                                   formData,
                                   {
                                       headers: {
                                           // Remove Content-Type header to let browser set it automatically with boundary
                                           Authorization: `Bearer ${token}`,
                                       },
                                       timeout: 120000, // Increased timeout to 2 minutes
                                       onUploadProgress: (progressEvent) => {
                                           const percentCompleted = Math.round(
                                               (progressEvent.loaded * 100) / progressEvent.total
                                           );
                                       },
                                   }
                               );


                if (response.status === 200 || response.status === 201) {
                    results.push({ success: true, file: file.name, data: response.data });
                } else {
                    results.push({ success: false, file: file.name, error: `Upload failed with status: ${response.status}` });
                }
            } catch (error) {
                let errorMessage = "Upload failed";
                if (error.response) {
                    errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
                } else if (error.code === 'ECONNABORTED') {
                    errorMessage = "Upload timeout - file may be too large";
                } else if (error.message) {
                    errorMessage = error.message;
                }
                results.push({ success: false, file: file.name, error: errorMessage });
            }
        }

        return results;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newFilesToUpload = files.filter(f => !f.isExisting);
        if (newFilesToUpload.length === 0) {
            alert(translator(translate.ISA_PleaseSelectNewFile, "กรุณาเลือกไฟล์ใหม่ที่ต้องการอัปโหลด"));
            return;
        }

        setUploading(true);
        try {
            const fileList = newFilesToUpload.map((f) => f.file);
            const results = await uploadAllFiles(fileList);
            const successfulUploads = results.filter((r) => r.success);
            const failedUploads = results.filter((r) => !r.success);

            if (failedUploads.length > 0) {
                const failedDetails = failedUploads.map((f) => `${f.file}: ${f.error}`).join('\n');
                alert(`${translator(translate.ISA_SomeFilesUploadFailed, "บางไฟล์อัปโหลดไม่สำเร็จ")}:\n${failedDetails}`);
            }

            if (successfulUploads.length > 0) {
                if (onUploadSuccess) {
                    onUploadSuccess();
                }
                setFiles([]);
                onClose();
            }
        } catch (error) {
            alert(translator(translate.ISA_AUTO_UPLOAD_FAILED, "การอัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง"));
        } finally {
            setUploading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle disableTypography>
                <Typography variant="h6">{translator(translate.ISA_AttachmentFor, "Attachment for")}: {relatedId}</Typography>
                <IconButton onClick={onClose} style={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {loadingExisting && <div className="text-center">{translator(translate.ISA_LoadingExistingFiles, "กำลังโหลดไฟล์แนบเดิม")}...</div>}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, minHeight: 100 }}>
                    {files.map((f, idx) => (
                        <div key={idx} style={{ position: 'relative', width: 160, minHeight: 56, borderRadius: 6, overflow: 'hidden', background: '#fff', border: '1px solid #ddd', display: 'flex', alignItems: 'center', padding: '8px', gap: 8 }}>
                            <div style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5', borderRadius: 6, overflow: 'hidden' }}>
                                {
                                    // if image file, show preview image (existing files use fileUrl, new files use blob preview)
                                    (function(){
                                        const imgExts = ['jpg','jpeg','png','gif','bmp','webp'];
                                        const ext = (f.name || '').toLowerCase().split('.').pop();
                                        if (imgExts.includes(ext)) {
                                            const src = f.isExisting ? (f.fileUrl || f.preview) : f.preview;
                                            if (src) {
                                                return (<img src={src} alt={f.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />);
                                            }
                                        }
                                        // fallback to icon
                                        const cls = getIconClassForExtension(f.name);
                                        return (<i className={cls} style={{ fontSize: 20, color: '#666' }} />);
                                    })()
                                }
                            </div>
                            <div style={{ flex: 1, overflow: 'hidden' }}>
                                <div style={{ fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{f.name}</div>
                                <div style={{ fontSize: 12, color: '#666' }}>{f.isExisting ? translator(translate.ISA_Attached, "แนบแล้ว") : translator(translate.ISA_ReadyToUpload, "พร้อมอัปโหลด")}</div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                <button
                                    type="button"
                                    onClick={() => handleRemove(idx)}
                                    style={{
                                        background: f.isExisting ? '#dc3545' : 'orange',
                                        color: '#fff', border: 'none', borderRadius: 4, padding: '6px 8px', cursor: 'pointer', fontSize: '12px'
                                    }}
                                    title={f.isExisting ? translator(translate.ISA_AUTO_DELETE_FILE, "ลบไฟล์") : translator(translate.ISA_CancelFile, "ยกเลิกไฟล์")}
                                >
                                    {f.isExisting ? translator(translate.ISA_Delete, "ลบ") : translator(translate.ISA_Cancel, "ยกเลิก")}
                                </button>
                                {f.isExisting && (
                                    <a href={f.fileUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: '#007bff', textDecoration: 'none', textAlign: 'center' }}>{translator(translate.ISA_View, "ดู")}</a>
                                )}
                            </div>
                        </div>
                    ))}
                    <div
                        style={{
                            width: 80, height: 80, border: '2px dashed #bbb', borderRadius: 6, display: 'flex',
                            alignItems: 'center', justifyContent: 'center', cursor: 'pointer', background: '#fafafa'
                        }}
                        onClick={handleAddClick}
                    >
                        <span style={{ fontSize: 32, color: '#bbb' }}>+</span>
                        <input
                            ref={fileInputRef}
                            type="file"
                            style={{ display: 'none' }}
                            accept={acceptAttr}
                            multiple
                            onChange={handleFileChange}
                        />
                    </div>
                </div>
                <div className="alert alert-info" style={{ fontSize: 13, marginTop: 16 }}>
                    {translator(translate.ISA_SupportedFileTypes, "รองรับไฟล์ Excel (.xlsx, .xls), CSV หรือไฟล์รูปภาพ (jpg, png, jpeg, gif, bmp, webp)")} <br />
                    {translator(translate.ISA_AUTO_CHECK_FILE_FORMAT, "กรุณาตรวจสอบรูปแบบไฟล์ก่อนนำเข้า")}
                </div>
                {uploading && (
                    <div className="alert alert-warning" style={{ fontSize: 13, marginTop: 8 }}>
                        {translator(translate.ISA_Uploading, "กำลังอัปโหลด... กรุณารอสักครู่")}
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary" disabled={uploading}>
                    {translator(translate.ISA_Cancel, "ยกเลิก")}
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                    disabled={files.filter(f => !f.isExisting).length === 0 || uploading}
                >
                    {uploading ? translator(translate.ISA_Uploading, "กำลังอัปโหลด") + '...' : translator(translate.ISA_Upload, "อัปโหลด")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default StockCountUploadDialog;